import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getDiarias({ tp_id, company_id, manufacturer_id }) {
  try {
    const { data } = await authHttp().get(
      routes.urlGetVehiclesDaily({ tp_id, company_id, manufacturer_id }),
    )
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveDiarias(rows) {
  try {
    const { data } = await authHttp().post(routes.urlPostVehiclesDaily, rows)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateDiaria(row) {
  try {
    const { data } = await authHttp().put(routes.urlPutVehiclesDaily(row.id), row)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
